// ============================================================
// Hero Module - Typing Effect and Dynamic Text
// ============================================================

let typingRunId = 0;

export function initHeroAnimations(force = false) {
  const typingText = document.getElementById('typing-text');

  if (!typingText) return;

  if (typingText.dataset.typingInitialized && !force) return;

  typingRunId += 1;
  const currentRunId = typingRunId;

  const existingCursor = typingText.querySelector('.typing-cursor');
  if (existingCursor) {
    existingCursor.remove();
  }

  // ============================================================
  // Typing Effect
  // ============================================================
  const text = typingText.textContent;
  const speed = 100; // ms per character

  typingText.dataset.typingInitialized = 'true';

  // Clear original text
  typingText.textContent = '';

  // Type out the text
  let index = 0;
  const typeText = () => {
    if (currentRunId !== typingRunId) return;
    if (index < text.length) {
      typingText.textContent += text.charAt(index);
      index++;
      setTimeout(typeText, speed);
    } else {
      // Add cursor animation after typing completes
      addCursorAnimation();
    }
  };

  // Start typing after a small delay
  setTimeout(typeText, 500);

  // ============================================================
  // Add Cursor Animation
  // ============================================================
  const addCursorAnimation = () => {
    let style = document.getElementById('typingCursorStyle');
    if (!style) {
      style = document.createElement('style');
      style.id = 'typingCursorStyle';
      style.textContent = `
      .typing-cursor {
        display: inline;
        animation: typingCursor 0.7s infinite;
      }

      @keyframes typingCursor {
        0%, 49% {
          opacity: 1;
        }
        50%, 100% {
          opacity: 0;
        }
      }
    `;
      document.head.appendChild(style);
    }

    const cursor = document.createElement('span');
    cursor.className = 'typing-cursor';
    cursor.textContent = '|';
    typingText.appendChild(cursor);
  };
}
